module.exports = __webpack_public_path__ + "img/bg.6474240c.webp";